module.exports = __webpack_public_path__ + "img/image_015.fdf75b8c.jpg";